// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishListNew/ProfessionDetail.less
// module id = 961
// module chunks = 0